module.exports = __webpack_public_path__ + "img/121.6b8486dd.jpg";